// extracted by mini-css-extract-plugin
module.exports = {"updateProfileBtnWrapper":"styles-module__updateProfileBtnWrapper___rAfvM","updateProfileBtn":"styles-module__updateProfileBtn___2Bq-n"};